import { createContext, useContext, useMemo, useState } from "react";
import { SelectionPayrollClosingContextValue, SelectionPayrollClosingProviderProps } from "../types/PayrollClosing";
import { ICommissionCycle } from "@/Common/api/types/CommissionCycle";

const SelectionPayrollClosingContext = createContext<SelectionPayrollClosingContextValue | null>(null);

const SelectionPayrollClosingProvider = (props: Readonly<SelectionPayrollClosingProviderProps>) => {
	const { children } = props;

	const [selectedCommissionCycle, setSelectedCommissionCycle] = useState<ICommissionCycle | undefined>(undefined);

	const value = useMemo(
		() => ({
			selectedCommissionCycle,
			setSelectedCommissionCycle,
		}),
		[selectedCommissionCycle]
	);

	return <SelectionPayrollClosingContext.Provider value={value}>{children}</SelectionPayrollClosingContext.Provider>;
};

const useSelectionPayrollClosing = () => {
	const context = useContext(SelectionPayrollClosingContext);
	if (!context) {
		throw new Error("useSelectionPayrollClosing must be used within a SelectionPayrollClosingProvider");
	}
	return context;
};

export { SelectionPayrollClosingProvider, useSelectionPayrollClosing };
